import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./css/CaptainReg.css";
import "bootstrap/dist/css/bootstrap.css";
import SideNav from "./SideNav";
import TopRootDiv from "./TopRootDiv";
import SherDineNav from "./SherDineNav";
import Select from 'react-select'
import { ToastContainer, toast } from 'react-toastify';
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'

function CaptainReg() {
	const [collapsed, setCollapsed] = useState(false);
	const [Captain_Name, setCaptainName] = useState("");
	const [Captain_Kitchen, setCaptainKitchen] = useState("");
	const [Captain_Mobile, setCaptainMobile] = useState();
	const [Database, setDatabase] = useState(localStorage.getItem("DB"));
	const [imgCode, setImgCode] = useState(localStorage.getItem("imgCode"));
	const [company, setCompany] = useState(localStorage.getItem("Company"));
	const location = useLocation(null);
    const [selectedOption, setSelectedOption] = useState({})
	const [item, setItem] = useState({});
    const [itemDetails, setItemDetails] = useState({})
    const [loading, setLoading] = useState(false); // State to track loading indicator
    const [Kitchens, setKitchens] = useState([]);
    const [loadingKitchen, setLoadingKitchen] = useState(true); // To track the loading state

	const api_base_url = process.env.REACT_APP_API_BASE_URL;

	const handleFocusSelect = (itemField) => {
        setItem({
            ...item,
            [itemField]: ""
        })
    }

    useEffect(() => {
        // Fetch categories from the backend
        fetch(`${api_base_url}/GetKitchen/${Database}`)
            // .then((response) => response.json())
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then((KitData) => {
                if (KitData.length === 0) {
                    //("error kitc then if");
                    toast.error("No kitchen found.");
                    setKitchens([{ value: '', label: 'No Data' }]);
                } else {
                    setKitchens(KitData.map((Kitch) => ({
                        value: Kitch.Kitchen_id,
                        label: Kitch.KitchenName
                    })))
                }
            })
            .catch((error) => {
                //("error kitc catch");
                console.error("Error fetching kitc:", error)
                toast.error("Something went wrong while fetching Kitchen Data.",
                    {
                        className: 'custom-toast',
                        bodyClassName: 'custom-toast-container',
                        closeButtonClassName: 'custom-toast-close-button',
                        onClose: () => { }
                    });
                    setKitchens([{ value: '', label: 'No Data' }]); // Show "No Data" in the dropdown on error
            })
            .finally(() => {
                setLoadingKitchen(false); // Set loading to false when fetch is complete
            });
    }, [api_base_url, Database]);

	// const handleSelectField = (value, fieldName, itemField) => {
    //     setSelectedOption((prev) => ({
    //         ...prev,
    //         [fieldName]: value
    //     }))
    //     setItemDetails((prev) => ({
    //         ...prev,
    //         [fieldName]: value
    //     }))
    //     item[itemField] = ''
    // }

	const toggleSidebar = () => {
		setCollapsed(!collapsed);
	};
	

	// Function to handle selection
	const handleSelectField = (val, optionType, field) => {
		//("Selected kitchen:", val.label); // Log selected kitchen name
		setSelectedOption((prev) => ({
			...prev,
			[optionType]: val
		}));
	  
		// Set Captain_Kitchen specifically when 'kitchen' field is selected
		if (field === 'kitchen') {
			setCaptainKitchen(val.label); // Use val.label for the kitchen name
		}
	};
	
	// Function to handle form submission
	const handleSubmit = async () => {
		if (!Captain_Name || !Captain_Kitchen || !Captain_Mobile) {
			//(Captain_Name, Captain_Kitchen, Captain_Mobile);
			alert("Please fill in all fields.");
			return;
		}
	
		const data = {
			Captain_Name: Captain_Name,
			Captain_Kitchen: Captain_Kitchen,
			Captain_Mobile: Captain_Mobile,
		};
	//("Data", data);
	
		try {
			const response = await fetch(`${api_base_url}/CaptainReg/${Database}`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(data),
			});
	
			if (response.ok) {
				//("Data submitted successfully");
				// setCaptainName("");
				// setSelectedOption("");
				// setCaptainMobile("");
				// handleSelectField("");
				// handleFocusSelect("");
				setCaptainName("");
				setCaptainKitchen("");
				setCaptainMobile("");
				setSelectedOption((prev) => ({ ...prev, Kitchen: null }));
			} else {
				console.error("Failed to submit data");
			}
		} catch (error) {
			console.error("Error:", error);
		}
	};
	

	// const handleSelectField = (val, optionType, field) => {
	// 	//("Selected kitchen:", val); // This will log the selected kitchen option
	// 	setSelectedOption((prev) => ({
	// 	  ...prev,
	// 	  [optionType]: val
	// 	}));
	//   };
	  
	// const handleSubmit = async () => {
	// 	if (!Captain_Name || !Captain_Kitchen) {
	// 		//(Captain_Name, Captain_Kitchen, Captain_Mobile);
			
	// 		alert("Please fill in all fields.");
	// 		return;
	// 	}

	// 	const data = {
	// 		CaptainName: Captain_Name,
	// 		CaptainKitchen: Captain_Kitchen,
	// 		CaptainMobile: Captain_Mobile,
	// 	};

	// 	try {
	// 		//("Try");
	// 		const response = await fetch(`${api_base_url}/CaptainReg/${Database}`, {
	// 			method: "POST",
	// 			headers: {
	// 				"Content-Type": "application/json",
	// 			},
	// 			body: JSON.stringify(data),
	// 		});

	// 		if (response.ok) {
	// 			//("Data submitted successfully");
	// 			// Optionally, reset the form fields here
	// 			setCaptainName("");
	// 			setCaptainKitchen("");
	// 			setCaptainMobile("");
	// 		} else {
	// 			console.error("Failed to submit data");
	// 		}
	// 	} catch (error) {
	// 		console.error("Error:", error);
	// 	}
	// };
	// if (productID) {
	//     handleSubmit();
	// }

	const handleCaptainNameChange = (event) => {
		setCaptainName(event.target.value);
	};
	// //(company, "FGHJK");
	const handleCaptainMobileChange = (value) => {
		setCaptainMobile(value);
	};

	useEffect(() => {
		const handleWindowResize = () => {
			if (window.innerWidth <= 768) {
				setCollapsed(true);
			} else {
				setCollapsed(false);
			}
		};

		window.addEventListener("resize", handleWindowResize);

		return () => {
			window.removeEventListener("resize", handleWindowResize);
		};
	}, []);

	const navigate = useNavigate();

	const customStyles = {
        option: (provided, state) => ({
            ...provided,
            width: '100%',
            fontSize: '0.881rem',
            fontFamily: 'Nunito',
            backgroundColor: state.isSelected ? '#c8cbcf' : '#FFF',
            backgroundColor: state.isFocused ? '#c8cbcf' : '#FFF',
            color: state.isFocused ? '#000' : '#000',
            ':active': {
                ...provided[':active'],
                backgroundColor: '#c8cbcf'
            }
        }),
        input: (provided) => ({
            ...provided,
            // height: '2.5rem',
            width: '100% !important',
            fontSize: '0.881rem',
            fontFamily: 'Nunito',
            cursor: 'none',
            '&:hover': {
                cursor: 'text'
            },
            '&:focus': {
                cursor: 'default',
            },
            // display: 'none', 
            color: "#2B3034"
        }),
        valueContainer: (provided) => ({
            ...provided,
            overflow: 'hidden',
            fontSize: '0.881rem',
        }),
        indicatorSeparator: (provided, state) => ({
            ...provided,
            // display: 'none', 
        }),
        dropdownIndicator: (provided, state) => ({
            ...provided,
            height: '2.5rem', // Adjust height of dropdown indicator to match control height
            marginTop: 0, // Adjust vertical alignment if needed
        }),
        control: (provided, state) => ({
            ...provided,
            width: '100% !important',
            // height: '2.5rem',
            height: '1px',
            fontSize: '0.881rem',
            fontFamily: 'Nunito',
            height: '2.5rem',
            border: '1px solid #D5D5D5',
            borderRadius: '0.313rem',
            textAlign: 'left',
            boxShadow: 'none',
            '&:hover': {
                border: '1px solid #C6C6C6',
            },
            '&:focus': {
                outline: 'none', // Remove outline on focus
                cursor: 'default', // Remove cursor on focus
            },
        }),
        placeholder: (provided, state) => ({
            ...provided,
            fontSize: '0.881rem',
            // lineHeight: '2.5rem',
        }),
        menu: (provided, state) => ({
            ...provided,
            fontSize: '.9rem',
            textAlign: 'left',
            // height: '2.5rem',
        }),
        container: (provided) => ({
            ...provided,
            height: '100%', // Set the height to 1px
        }),
    };

	const handleCancel = () => {
		navigate("/basemenureg", {
			state: "CaptainCancel",
		});
	};

	const handleSaveArea = () => { };

	const [sideNav, setSideNav] = useState(false);
	const handleSideNav = (state) => {
		setSideNav(state);
	};
	const [falseState, setFalseState] = useState(null);

	return (
		<div className="CaptainRegMainDiv">
			<SherDineNav
				sideNav={(state) => handleSideNav(state)}
				falseState={falseState}
			/>
			<div className="CaptainRegContentDiv">
				<SideNav
					focus={"Menu"}
					state={sideNav}
					falseState={(state) => setFalseState(state)}
				/>
				<div className="CaptainRegContentSideBarRight">
					<div className="CaptainRegSidebar">
						<TopRootDiv
							image={"Menu Management"}
							root={["Menu Management", "Base Menu"]}
							section={"Add Captain"}
						/>
					</div>
					<div className="Container_Menu CaptainRegForm">
						<div className="Captain_Details_span">
							<span>Captain Details</span>
							<div className=" AddItem_Buttons AddItem_Buttons_CaptainAreaReg">
								<button
									className="btn_cancel btn_cancel_CaptainAreaReg"
									onClick={handleCancel}
								>
									Cancel
								</button>
								<button
									className="btn_Save btn_Savel_CaptainAreaReg"
									onClick={handleSubmit}
								>
									Save
								</button>
							</div>
						</div>
						{/* <div className='CaptainRegForm_Contents '> */}
						{/* <div className="CaptainRegForm_part">
							<div className="CaptainRegForm_part_spanInput">
								<span>Captain Name</span>
								<input
									className="CaptainName"
									type="text"
									value={CaptainName}
									onChange={handleCaptainNameChange}
								/>
							</div>
							<div className="CaptainRegForm_part_spanInput">
								<span>Kitchen</span>
								<input
									className="CaptainKitchen"
									type="text"
									value={CaptainKitchen}
									onChange={handleCaptainCodeChange}
								/>
							</div>
							<div className="CaptainRegForm_part_spanInput">
								<span>Mobile</span>
								<input
									className="CaptainKitchen"
									type="text"
									value={CaptainKitchen}
									onChange={handleCaptainCodeChange}
								/>
							</div>
						</div> */}
						<div className='CaptainRegForm_part'>
							<div className='CaptainRegForm_part_spanInput'>
								<span>Captain Name</span>
								{/* <input type="text" /> */}
								<input className="CaptainName" type="text" 
								value={Captain_Name} 
								onChange={handleCaptainNameChange} />
							</div>
							<div className='CaptainRegForm_part_spanInput'>
								<span>Kitchen</span>
								{/* <input type="text" /> */}
								{/* <input className="CaptainName" type="text" value={Captain_Kitchen} onChange={setCaptainKitchen} /> */}
								<Select
									// className={variantRequireErrorTimeOut ? "varientErrorColor" : ""}
									styles={customStyles}
									value={selectedOption.Kitchen}
									inputValue={item.kitchen}
									onFocus={() => handleFocusSelect('kitchen')}
									onChange={(val) => handleSelectField(val, 'Kitchen', 'kitchen')}
									// options={Kitchen_Options}
									// options={Kitchens.map((KitData) => ({
									//     value: KitData.Kitchen_id,
									//     label: KitData.KitchenName
									// }))}
									options={loading ? [{ value: '', label: 'Loading...' }] : Kitchens} // Show loading text while fetching
								/>
							</div>
							<div className='CaptainRegForm_part_spanInput'>
								<span>Captain Mobile</span>
								{/* <input type="text" /> */}
								<PhoneInput
									className="CaptainName"
									placeholder="Enter phone number"
									value={Captain_Mobile}
									onChange={handleCaptainMobileChange}
								/>
								{/* <input className="CaptainName" 
								type="number" value={Captain_Mobile} 
								onChange={handleCaptainMobileChange} /> */}
							</div>
						</div>
						{/* <div className='CaptainRegForm_part'> */}
							{/* <div className='CaptainRegForm_part_spanInput'>
								<span>Captain Mobile</span>
								{/* <input type="text" /> */}
								{/* <PhoneInput
									className="CaptainName"
									placeholder="Enter phone number"
									value={Captain_Mobile}
									onChange={handleCaptainMobileChange}/> * /}
								<input className="CaptainName" 
								type="number" value={Captain_Mobile} 
								onChange={handleCaptainMobileChange} />
							</div>
						</div> */}
						{/* </div> */}
						{/* <div className='CaptainAreaReg_areaDetails_buttons'>
                            <button className='btn_cancel' onClick={handleCancel}>Cancel</button>
                            <button className='btn_Save'>Save</button>
                        </div> */}
					</div>
				</div>
			</div>
		</div>
	);
}

export default CaptainReg;
